<template>
  <section class="relative z-10 py-32 bg-[#020617]">
    <div class="container mx-auto px-6 max-w-3xl">
      <div class="text-center mb-16 faq-fade-in">
        <span class="text-[10px] tracking-[0.4em] text-indigo-400 uppercase font-medium">FAQ</span>
        <h2 class="text-3xl md:text-4xl font-bold tracking-tight text-white mt-4">{{ displayedContent.faqTitle }}</h2>
        <div class="h-px w-16 bg-indigo-500/50 mx-auto mt-6"></div>
      </div>

      <div class="space-y-3">
        <div
          v-for="(faq, index) in faqs"
          :key="index"
          class="faq-fade-in border border-white/5 rounded-2xl transition-colors duration-300"
          :class="openIndex === index ? 'border-indigo-500/30 bg-indigo-500/5' : 'bg-white/[0.02] hover:bg-white/[0.04]'"
          :style="{ animationDelay: index * 0.08 + 's' }"
        >
          <button
            @click="openIndex = openIndex === index ? null : index"
            class="w-full text-left p-5 md:p-6 flex items-center justify-between group"
          >
            <span class="text-sm md:text-base font-medium text-white pr-4">{{ displayedContent[faq.questionKey] }}</span>
            <div
              class="w-8 h-8 rounded-full border border-white/10 flex items-center justify-center flex-shrink-0 transition-all duration-300"
              :class="openIndex === index ? 'bg-indigo-500/20 border-indigo-400/50 rotate-45' : ''"
            >
              <svg class="w-3.5 h-3.5 text-slate-400 transition-transform" :class="openIndex === index ? 'rotate-90' : ''" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
              </svg>
            </div>
          </button>
          <div class="faq-answer-wrapper" :class="{ 'faq-answer-open': openIndex === index }">
            <div class="faq-answer-inner">
              <div class="px-5 md:px-6 pb-5 md:pb-6">
                <p class="text-sm text-slate-400 leading-relaxed">{{ displayedContent[faq.answerKey] }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'
import { translations } from '../const'

const props = defineProps({
  lang: {
    type: String,
    default: 'en'
  }
})

const openIndex = ref(null)

const displayedContent = computed(() => translations[props.lang])

const faqs = [
  { questionKey: 'faq1Q', answerKey: 'faq1A' },
  { questionKey: 'faq2Q', answerKey: 'faq2A' },
  { questionKey: 'faq3Q', answerKey: 'faq3A' },
  { questionKey: 'faq4Q', answerKey: 'faq4A' },
  { questionKey: 'faq5Q', answerKey: 'faq5A' }
]
</script>

<style scoped>
.faq-answer-wrapper {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.4s ease-out;
}

.faq-answer-wrapper.faq-answer-open {
  grid-template-rows: 1fr;
}

.faq-answer-inner {
  overflow: hidden;
}

/* 本地渐入动画，不依赖全局 reveal-on-scroll */
.faq-fade-in {
  opacity: 0;
  animation: faqFadeIn 0.6s ease-out forwards;
}

@keyframes faqFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>